module.exports = __webpack_public_path__ + "static/media/articles5.99bcca9c.png";